module.exports = __webpack_public_path__ + "images/165092a3232f56f9edf79d391e25e969-Group_place_keypad.svg";